import { v4 as uuidv4 } from 'uuid';

const VISITOR_ID_COOKIE_NAME = 'revoyager_visitor_id';
const COOKIE_EXPIRY_DAYS = 365;

/**
 * Generate a new unique visitor ID
 */
export function generateVisitorId(): string {
  return uuidv4();
}

/**
 * Get visitor ID from cookie
 */
export function getVisitorIdFromCookie(): string | null {
  if (typeof window === 'undefined') return null;

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === VISITOR_ID_COOKIE_NAME) {
      return value;
    }
  }
  return null;
}

/**
 * Set visitor ID cookie
 */
export function setVisitorIdCookie(visitorId: string): void {
  if (typeof window === 'undefined') return;

  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);

  document.cookie = `${VISITOR_ID_COOKIE_NAME}=${visitorId}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Get or create visitor ID
 * This will check for an existing cookie, or create a new one if it doesn't exist
 */
export function getOrCreateVisitorId(): string {
  let visitorId = getVisitorIdFromCookie();

  if (!visitorId) {
    visitorId = generateVisitorId();
    setVisitorIdCookie(visitorId);
  }

  return visitorId;
}

/**
 * Remove visitor ID cookie (useful for testing or account linking)
 */
export function clearVisitorId(): void {
  if (typeof window === 'undefined') return;

  document.cookie = `${VISITOR_ID_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
